export default __webpack_public_path__ + "static/media/property-for-rent.d36318eb.jpeg";